import './mintahoe/style';
import FormStructure from './mintahoe/form_structure';

export default FormStructure;